import React, { Component } from "react";
import Tick from "./../asset/images/tick.svg";
import Cancel from "./../asset/images/cancel.svg";
import CustomButton from "../components/CustomButton";
import { Form } from "react-bootstrap";
import { word } from "../words.js";

import gsap from "gsap";

import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

const mobileRegex = RegExp(/09(0[1-9]|1[0-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileError: "",
      codeError: "",
      mobileValue: "",
      codeValue: "",
      mobileDisabled: false,
      codeDisabled: false,
      validationForm: false,
      time: {},
      seconds: 0,
      showResend: false,
    };

    this.mobileHandleChange = this.mobileHandleChange.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.verificationAnimateComplete =
      this.verificationAnimateComplete.bind(this);
    this.codeHandleChange = this.codeHandleChange.bind(this);
    this.sendCode = this.sendCode.bind(this);

    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);

    this.mobileInput = React.createRef();
    this.verificationInput = React.createRef();
  }

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    hours = hours + "";
    minutes = minutes + "";
    seconds = seconds + "";

    let obj = {
      h: hours.padStart(2, "0"),
      m: minutes.padStart(2, "0"),
      s: seconds.padStart(2, "0"),
    };
    return obj;
  }

  componentDidMount() {
    this.mobileInput.current.focus();
    // gsap.to(".validationContainer", {x: 500, duration: 0});
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  startTimer() {
    let totalsecend = 180;
    this.setState({
      seconds: totalsecend,
      time: this.secondsToTime(totalsecend),
    });
    this.timer = setInterval(this.countDown, 1000);
    this.setState({ showResend: false });
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      this.setState({ showResend: true });
      clearInterval(this.timer);
    }
  }

  hideModal() {
    this.props.onCancel();
  }

  mobileHandleChange(event) {
    let telephone = event.target.value;
    if (telephone !== "0" && telephone !== "") {
      if (!Number(telephone)) return;
    }
    this.setState({ mobileValue: event.target.value });
  }

  codeHandleChange(event) {
    let telephone = event.target.value;
    if (telephone !== "0" && telephone !== "") {
      if (!Number(telephone)) return;
    }
    this.setState({ codeValue: event.target.value });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.onConfirm();
    }
  }

  verificationAnimateComplete() {
    this.verificationInput.current.focus();
  }

  onConfirm() {
    if (!this.state.validationForm) {
      if (this.state.mobileValue.length < 1) {
        this.setState({
          mobileError: word[this.props.currentLang.tag]["userLoginText"],
        });
        return;
      } else {
        this.setState({ mobileError: "" });
      }

      if (mobileRegex.test(this.state.mobileValue)) {
        this.setState({ mobileError: "" });
      } else {
        this.setState({
          mobileError: word[this.props.currentLang.tag]["notValidMobileNumber"],
        });
        return;
      }

      this.sendCode();
    } else {
      if (this.state.codeValue.length < 1) {
        this.setState({
          codeError: word[this.props.currentLang.tag]["verifyError"],
        });
        return;
      } else {
        this.setState({ codeError: "" });
      }

      if (this.state.codeValue.length < 5) {
        this.setState({
          codeError: word[this.props.currentLang.tag]["verifyNotCorrect"],
        });
        return;
      } else {
        this.setState({ codeError: "" });
      }

      let newmobile = this.state.mobileValue;
      if (newmobile.startsWith("0")) {
        newmobile = newmobile.substring(1);
        newmobile = "+98" + newmobile;
      }

      let data = {
        mobile: newmobile,
        code: this.state.codeValue,
      };

      this.setState({ mobileDisabled: true });

      fetch("https://api.sepandplus.ontco.com/publicapi/LoginCustomer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          //console.log(result);
          if (result.status === 200) {
            this.setState({ showResend: false });
            clearInterval(this.timer);

            this.props.onLoginClick(newmobile, result.token);
          } else {
            this.setState({ mobileDisabled: false, codeError: result.message });
          }
        })
        .catch((err) => {
          //console.log(err);
          this.setState({ mobileDisabled: false });
        });
    }
  }

  sendCode() {
    let newmobile = this.state.mobileValue;
    if (newmobile.startsWith("0")) {
      newmobile = newmobile.substring(1);
      newmobile = "+98" + newmobile;
    }

    let data = {
      mobile: newmobile,
      country: "IR",
    };

    this.setState({ mobileDisabled: true });

    fetch(
      "https://api.sepandplus.ontco.com/publicapi/sendCodeToLoginCustomer",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        //console.log(result);
        if (result.status === 200) {
          if (this.state.showResend) {
            this.setState({ showResend: false });
            clearInterval(this.timer);
          } else {
            this.setState(
              {
                validationForm: true,
                codeValue: "",
                codeError: "",
                codeDisabled: false,
              },
              () => {
                gsap.to(".mobileContainer", {
                  x: -400,
                  duration: 0.4,
                  ease: "sine.out",
                });
                gsap.to(".dialogContentContainer", {
                  minHeight: 155,
                  duration: 0.4,
                  ease: "sine.out",
                });
                gsap.to(".loginLinks", {
                  opacity: 1,
                  duration: 0.2,
                  delay: 0.2,
                  ease: "sine.in",
                });
                gsap.to(".mobileContainer", { opacity: 0, duration: 0.2 });
                gsap.fromTo(
                  ".validationContainer",
                  { x: 400 },
                  { x: 0, duration: 0.3, ease: "sine.in" }
                );
                gsap.to(".validationContainer", {
                  opacity: 1,
                  duration: 0.2,
                  delay: 0.2,
                  onComplete: this.verificationAnimateComplete,
                });
              }
            );
          }

          this.startTimer();
          this.setState({ mobileDisabled: false });
        } else {
          this.setState({ mobileDisabled: false, mobileError: result.message });
        }
      })
      .catch((err) => {
        //console.log(err);
        this.setState({ mobileDisabled: false });
      });
  }

  onResendCode() {
    this.sendCode();
  }

  onChangeNumber() {
    this.setState({ mobileDisabled: false, mobileValue: "" });
    gsap.to(".mobileContainer", {
      x: 0,
      duration: 0.4,
      ease: "sine.in",
      onComplete: () => {
        this.mobileInput.current.focus();
      },
    });
    gsap.to(".dialogContentContainer", {
      minHeight: 130,
      duration: 0.4,
      ease: "sine.in",
    });
    gsap.to(".loginLinks", {
      opacity: 0,
      duration: 0.2,
      ease: "sine.out",
      onComplete: () => {
        this.setState({ showResend: false });
        clearInterval(this.timer);
      },
    });
    gsap.to(".mobileContainer", { opacity: 1, duration: 0.2 });
    gsap.to(".validationContainer", {
      x: 400,
      duration: 0.3,
      ease: "sine.out",
      onComplete: () => {
        this.setState({ validationForm: false });
      },
    });
    gsap.to(".validationContainer", { opacity: 0, duration: 0.2 });
  }

  render() {
    return (
      <div
        className={
          this.props.currentLang.direction === "rtl"
            ? "dialogBox IRANSansMobileBoldFont"
            : "dialogBox SFUIDisplayBoldFont"
        }
        style={{
          direction: this.props.currentLang.direction,
          maxWidth: "350px",
        }}
      >
        <div
          className="dialogContentContainer"
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "fit-content",
            minHeight: "130px",
            position: "relative",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <Fade left opposite collapse when={!this.state.validationForm}>
                        
                    </Fade> */}

          {this.state.validationForm && (
            <div className="validationContainer">
              <div className="popupTitle">
                {word[this.props.currentLang.tag]["verificationCode"]}
              </div>
              <div className="popupSubTitle">
                {word[this.props.currentLang.tag]["verificationCodeSubtitle"]}
              </div>

              <div className="verificationTimeContainer">
                {this.state.time.m}:{this.state.time.s}
              </div>
              <Form.Control
                maxLength="5"
                className={
                  this.state.codeError !== ""
                    ? this.props.currentLang.direction === "rtl"
                      ? "inputStyle2 inputStyle2Error IRANSansMobileFont"
                      : "inputStyle2 inputStyle2Error SFUIDisplayFont"
                    : this.props.currentLang.direction === "rtl"
                    ? "inputStyle2 IRANSansMobileFont"
                    : "inputStyle2 SFUIDisplayFont"
                }
                placeholder={word[this.props.currentLang.tag]["code"]}
                type="tel"
                onChange={this.codeHandleChange}
                value={this.state.codeValue}
                disabled={this.state.mobileDisabled}
                onKeyPress={this.handleKeyPress.bind(this)}
                ref={this.verificationInput}
              />

              <div className="errorMessageContainer">
                {this.state.codeError}
              </div>
            </div>
          )}

          <div className="mobileContainer">
            <div className="popupTitle">
              {word[this.props.currentLang.tag]["userLogin"]}
            </div>
            <div className="popupSubTitle">
              {word[this.props.currentLang.tag]["userLoginText"]}
            </div>
            <div style={{ minHeight: "15px" }} />
            <Form.Control
              maxLength="11"
              className={
                this.state.mobileError !== ""
                  ? this.props.currentLang.direction === "rtl"
                    ? "inputStyle2 inputStyle2Error IRANSansMobileFont"
                    : "inputStyle2 inputStyle2Error SFUIDisplayFont"
                  : this.props.currentLang.direction === "rtl"
                  ? "inputStyle2 IRANSansMobileFont"
                  : "inputStyle2 SFUIDisplayFont"
              }
              placeholder={word[this.props.currentLang.tag]["mobileNumber"]}
              // placeholder="مثال: 09123456789"
              type="tel"
              name="mobile"
              id="mobile"
              onChange={this.mobileHandleChange}
              value={this.state.mobileValue}
              disabled={this.state.mobileDisabled}
              onKeyPress={this.handleKeyPress.bind(this)}
              ref={this.mobileInput}
            />

            <div className="errorMessageContainer">
              {this.state.mobileError}
            </div>
          </div>

          {/* <Fade left collapse when={this.state.validationForm}>
                        
                    </Fade> */}
        </div>

        {this.state.validationForm && (
          <div className="loginLinks">
            {this.state.showResend && (
              <div
                onClick={this.onResendCode.bind(this)}
                className={
                  this.props.currentLang.direction === "rtl"
                    ? "linkStyle IRANSansMobileBoldFont"
                    : "linkStyle SFUIDisplayBoldFont"
                }
                style={{ fontSize: "14px", marginTop: "0px" }}
              >
                {word[this.props.currentLang.tag]["resendCode"]}
              </div>
            )}
            <div
              onClick={this.onChangeNumber.bind(this)}
              className={
                this.props.currentLang.direction === "rtl"
                  ? "linkStyle IRANSansMobileBoldFont"
                  : "linkStyle SFUIDisplayBoldFont"
              }
              style={{ fontSize: "14px", marginTop: "10px" }}
            >
              {word[this.props.currentLang.tag]["changeNumber"]}
            </div>
          </div>
        )}

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "20px",
            alignItems: "center",
            direction: "ltr",
          }}
        >
          <div style={{ flex: "1" }}>
            <CustomButton
              title={word[this.props.currentLang.tag]["cancel"]}
              imgHeight={20}
              backColor="var(--black1)"
              imgWidth={20}
              minHeight="35px"
              img={Cancel}
              onClick={this.hideModal.bind(this)}
            />
          </div>
          <div style={{ minWidth: "5px" }} />
          <div style={{ flex: "1" }}>
            <CustomButton
              title={word[this.props.currentLang.tag]["confirm"]}
              disabled={this.state.mobileDisabled}
              imgHeight={20}
              imgWidth={20}
              minHeight="35px"
              img={Tick}
              onClick={this.onConfirm}
            />
          </div>
        </div>
      </div>
    );
  }
}
